import { Close, Edit } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from '../../services';
import InnerEditDialogForm from './InnerEditDialogForm';

interface EditStudyRequestDialogInterface {
	onSubmit: (props: any) => void;
	id: string;
}

const EditStudyRequestDialog: FC<EditStudyRequestDialogInterface> = ({
	onSubmit,
	id,
}) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	const handleSubmit = useCallback(
		(val: any) => {
			onSubmit(val);
			setOpen(false);
		},
		[onSubmit]
	);

	return (
		<>
			<IconButton
				onClick={handleClickOpen}
				title={t('Edit Study Request')}
				color="primary"
			>
				<Edit />
			</IconButton>
			<Dialog open={open} onClose={handleClose} fullWidth>
				<DialogTitle>
					{t('Edit Study Request')}
					<IconButton
						aria-label="close"
						onClick={handleClose}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<Close />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					{open && <InnerEditDialogForm handleSubmit={handleSubmit} id={id} />}
				</DialogContent>
			</Dialog>
		</>
	);
};

export default EditStudyRequestDialog;
